import React from 'react';

interface CurrentUser {
  country: string;
  display_name: string;
  email: string;
  id: string;
}

interface AppContextInterface {
  accessToken: string | null;
  currentUser: CurrentUser | null;
  filterType: string;
  setFilterType: (value: string) => void;
  setUpAccessToken: () => void;
  setCurrentUser: (user: any) => void;
}

export const MainContext = React.createContext<AppContextInterface>({
  accessToken: '' || null,
  currentUser: null,
  filterType: '',
  setFilterType: (value: string) => {},
  setUpAccessToken: () => {},
  setCurrentUser: (user: any) => {},
});
